<template>
  <div class="card card-info">
    <div class="card-header with-border">
      <h3 class="card-title">Manage</h3>
      <!--<button type="button" class="btn btn-primary" style="float: left" v-on:click="changestate()">+Add New</button>-->
    </div>
    <!-- /.box-header -->
    <!-- form start -->
    <div class="card-body">
      <div class="row" style="margin-top: 10px">
        <div class="col-md-12">
          <table class="table table-bordered table-color" id="table">
            <thead class="bg-info">
              <tr>
                <th>Sr. No.</th>
                <th>User Name</th>
                <th>Email</th>
                <th>Password</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, ind) in detail">
                <td>{{ind+1}}</td>
                <td>{{item.Name}}</td>
                <td>{{item.Email}}</td>
                <td>{{item.Password}}</td>
                <td align="center"><span v-if="item.EmailVerified" class="text-success">Verified</span>
                    <span v-else class="text-danger">Un-Verified</span></td>
                <td align="center">
                    <button v-if="!item.EmailVerified" v-on:click="verifyEmail(item.AdmissionFormUserID, true, ind)" class="btn btn-info" type="button">Verify</button>
                    <button v-else v-on:click="verifyEmail(item.AdmissionFormUserID, false, ind)" class="btn btn-danger" type="button">Un-Verify</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  const axios = require('axios').default;

  export default ({
    data() {
      return {

        detail: [],
      }
    },
    created: function () {
      this.loadstudentactivedetail();
    },

    updated: function () {
      $('#table').DataTable();
    },
    methods: {

      //changestate() {
      //  window.location.href = '/DC/StudentActiveInActive'

      //},

      loadstudentactivedetail() {
        var vm = this;
        axios.post('/api/AdmissionApi/loadAdmissionFormUsers')
          .then(function (response) {
            vm.detail = response.data.lst;
          })
          .catch(function (error) {
            console.log(error);
          });
      },

      verifyEmail(id, type, ind) {
        var vm = this;
        axios.post('/api/AdmissionApi/VerifyUser?ID=' + id + '&type=' + type)
          .then(function (response) {
            if (response.data.status) {
              vm.detail[ind].EmailVerified = type;
              toastr.success("Saved Successfully"); 
            }
            else {
              toastr.error("Verification Failed");
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      },
    }
  })

  function reload() {
    window.location.reload();
  }
</script>



// WEBPACK FOOTER //
// src/components/onlineadmission/onlineadmissionuser.vue